import { Outlet } from "react-router-dom";
import { Box } from "@chakra-ui/react";

const Container = () => {
  return (
    <Box display={"flex"}>
      <Box>
        <Outlet />
      </Box>
    </Box>
  );
};

export default Container;
